import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Modal } from "@appkit4/react-components/modal";
import { Button } from "@appkit4/react-components/button";
import { loginRequest, msalInstance } from "../../auth/msalConfig";
const TOTAL_IDLE_TIME = 60 * 60 * 1000; // 60 minutes

const WARNING_TIME = TOTAL_IDLE_TIME - 5 * 60 * 1000;// Show warning 5 minutes before timeout

const COUNTDOWN_TIME = (TOTAL_IDLE_TIME - WARNING_TIME) / 1000;
const IdleTimer = () => {
  const [lastActivity, setLastActivity] = useState(Date.now());
  const [showWarning, setShowWarning] = useState(false);
  const [countdown, setCountdown] = useState(COUNTDOWN_TIME);
  const [visible, setVisible] = useState(false);
  const navigate = useNavigate();
  const intervalRef = useRef<NodeJS.Timeout | null>(null);
  useEffect(() => {
    const resetTimer = () => {
      if (!showWarning) {
        setLastActivity(Date.now());
      }
    };
    const checkIdleTime = () => {
      const idleTime = Date.now() - lastActivity;
      if (idleTime >= TOTAL_IDLE_TIME) {
        logoutUser();
      } else if (idleTime >= WARNING_TIME && !showWarning) {
        setShowWarning(true);
        setVisible(true);
        startCountdown();
      }
    };
    const logoutUser = () => {
      clearInterval(intervalRef.current as NodeJS.Timeout);
      navigate("/logout");
    };
    const startCountdown = () => {
      if (intervalRef.current) return; // Prevent multiple intervals
      intervalRef.current = setInterval(() => {
        setCountdown((prev) => {
          if (prev <= 1) {
            clearInterval(intervalRef.current as NodeJS.Timeout);
            logoutUser();
            return 0;
          }
          return prev - 1;
        });
      }, 1000);
    };
    // Attach event listeners for activity tracking (DO NOT reset if modal is open)
    window.addEventListener("mousemove", resetTimer);
    window.addEventListener("keydown", resetTimer);
    window.addEventListener("click", resetTimer);
    window.addEventListener("scroll", resetTimer);
    // Periodically check for inactivity
    const interval = setInterval(checkIdleTime, 1000);
    return () => {
      window.removeEventListener("mousemove", resetTimer);
      window.removeEventListener("keydown", resetTimer);
      window.removeEventListener("click", resetTimer);
      window.removeEventListener("scroll", resetTimer);
      clearInterval(interval);
      clearInterval(intervalRef.current as NodeJS.Timeout);
    };
  }, [lastActivity, showWarning]);
  // Prevent modal from closing on interaction
  useEffect(() => {
    if (showWarning) {
      const timer = setInterval(() => {
        setCountdown((prev) => (prev > 0 ? prev - 1 : 0));
      }, 1000);
      return () => clearInterval(timer);
    }
  }, [showWarning]);
  const loginRedirect = async () => {
    await msalInstance.loginRedirect(loginRequest);
  };
  return (
    <>
      <Modal
        visible={visible}
        title="Session Timed Out"
        ariaLabel="Session Timed Out"
        closable={false} // Prevent closing by clicking on the close button
        maskCloseable={false} // Prevent closing by clicking outside modal
        modalStyle={{ width: "33.75rem" }}
        footerStyle={{ paddingTop: "8px", marginTop: "-8px", minHeight: "64px" }}
        bodyStyle={{ minHeight: "92px" }}
        footer={<Button onClick={loginRedirect}>Login</Button>}
      >
        <p>Your session is about to time out in:
          <span className="idleTimeoutCount">
            <b>
              {Math.floor(countdown / 60)}:
              {String(countdown % 60).padStart(2, "0")}
            </b>
          </span>
        </p>
        <br />
        <p>Please log in again. Note that you might need to re-upload files to fetch their results.</p>
      </Modal>
    </>
  );
};
export default IdleTimer;